"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function Shop() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true
  });
  return <section data-section-id="1943" id="shop-title" className="relative overflow-hidden bg-background text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -right-24 h-80 w-80 rounded-lg blur-3xl" style={{
      background: "radial-gradient(circle, hsl(215 60% 35% / 0.1) 0%, transparent 70%)"
    }} />

      <div ref={ref} className={`relative mx-auto w-full max-w-7xl px-5 pt-12 pb-16 sm:px-8 sm:pt-16 sm:pb-24 lg:pt-20 lg:pb-28 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <Breadcrumb className="mb-6 sm:mb-8">
          <BreadcrumbList className="text-[0.7rem] font-mono uppercase tracking-widest text-muted-foreground">
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/HomePage" className="text-foreground/70 hover:text-primary">
                  Home
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-muted-foreground" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-foreground">Shop</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        {}
        <div className="max-w-3xl">
          <h1 className="font-default text-5xl font-bold uppercase leading-[0.9] tracking-tighter sm:text-6xl md:text-7xl lg:text-8xl text-primary">
            Our Catch
          </h1>
          {}
          <span className="mt-4 block h-1 w-24 rounded-md bg-secondary sm:w-32" />

          {}
          <p className="mt-6 max-w-xl font-sans text-base text-foreground/80 sm:text-lg">
            Wild-caught, expertly cut, and delivered with care. Explore our premium selection of fresh and frozen seafood, sourced directly from the Gulf.
          </p>
        </div>
      </div>
    </section>;
}